import { Center, HStack, Icon, Link, Text, VStack, Wrap, WrapItem } from '@chakra-ui/react';
import ContentContainer from '~/containers/Content';

import { useRecoilValue } from 'recoil';
import platformAtom from '~/recoil/atom/platform';

import { AiFillEnvironment, AiFillPhone } from 'react-icons/ai';
import { FaLine } from 'react-icons/fa';
import { IoHome } from 'react-icons/io5';

import parsePhoneNumberFromString from 'libphonenumber-js';
import versionInfo from '~/constants/versionInfo';

const formatPhoneNumber = (numberString: undefined | string) => {
  if (!numberString) return '-';

  const phoneNumber = parsePhoneNumberFromString(numberString, 'TW');
  if (!phoneNumber) return '-';

  if (!phoneNumber.isValid()) {
    return '-';
  }

  const nationalNumber = phoneNumber.nationalNumber;
  return `0${nationalNumber?.replace(/^(\d{3})(\d{3})(\d{3})$/, '$1-$2-$3')}`;
};

export default function Footer() {
  const platform = useRecoilValue(platformAtom);
  const {
    PLATFORM_FULL_NAME,
    PLATFORM_TAX_NUMBER,
    PLATFORM_NAME_EN,
    PLATFORM_CONTACT_NUMBER,
    PLATFORM_CONTACT_ADDRESS,
  } = platform.contactInfo;

  const { socialLink } = platform;

  return (
    <Center bg="gray.100" py={3}>
      <ContentContainer bg="gray.100">
        <VStack align="stretch">
          <HStack>
            <Text fontSize="14px" fontWeight={700} color="secondary">
              {PLATFORM_NAME_EN}
            </Text>
          </HStack>

          {(!!socialLink?.FB || !!socialLink?.IG || !!socialLink?.LINE) && (
            <HStack>
              {socialLink.LINE && (
                <HStack>
                  <Icon as={FaLine} color="secondary" boxSize="1rem" />
                  <Link href={socialLink.LINE || ''} target="_blank">
                    <Text fontSize="sm" color="secondary">
                      LINE
                    </Text>
                  </Link>
                </HStack>
              )}
              {socialLink.FB && (
                <HStack>
                  <Icon as={FaLine} color="secondary" boxSize="1rem" />
                  <Link href={socialLink.LINE || ''} target="_blank">
                    <Text fontSize="sm" color="secondary">
                      LINE
                    </Text>
                  </Link>
                </HStack>
              )}
              {socialLink.IG && (
                <HStack>
                  <Icon as={FaLine} color="secondary" boxSize="1rem" />
                  <Link href={socialLink.LINE || ''} target="_blank">
                    <Text fontSize="sm" color="secondary">
                      LINE
                    </Text>
                  </Link>
                </HStack>
              )}
            </HStack>
          )}
          <HStack>
            <Icon as={AiFillPhone} color="secondary" boxSize="1rem" />
            <Text fontSize="sm" color="secondary">
              {formatPhoneNumber(PLATFORM_CONTACT_NUMBER)}
            </Text>
          </HStack>

          <HStack>
            <Icon as={AiFillEnvironment} color="secondary" boxSize="1rem" />
            <Text fontSize="sm" color="secondary">
              {PLATFORM_CONTACT_ADDRESS}
            </Text>
          </HStack>

          <HStack>
            <Icon as={IoHome} color="secondary" boxSize="1rem" />
            <Text fontSize="sm" color="secondary">
              {PLATFORM_FULL_NAME}/{PLATFORM_TAX_NUMBER}
            </Text>
          </HStack>

          <HStack spacing={0.5}>
            <Wrap spacing={1}>
              <WrapItem>
                <Text fontSize="xs" color="secondary">
                  © 2024 {PLATFORM_NAME_EN}., LTD. All Rights Reserved.
                </Text>
              </WrapItem>
              <WrapItem>
                <Text fontSize="xs" color="secondary">
                  version {versionInfo.version}
                </Text>
              </WrapItem>
            </Wrap>
          </HStack>
        </VStack>
      </ContentContainer>
    </Center>
  );
}
